export default __webpack_public_path__ + "static/media/FAQSageDashboard.cc187d62.svg";